'use strict';

module.exports['i18n_loc_get_default'] = require('./i18n_loc_get_default');
module.exports['i18n_loc_set_default'] = require('./i18n_loc_set_default');
//# sourceMappingURL=index.js.map